import React from 'react';

import TypedOption from 'components/form/TypedOption.component';
import Icon from 'components/generic/Icon.component';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import CN from './UiPage.module.scss'; // Since this is experiment, we can share the same .module.scss file

const IconsPanel = () => (
  <div data-bem="IconsPanel" className={CN.container}>
    <div className={CN.container}>
      <div className={CN.grid}>
        <div className={CN.elementsContainer}>
          <code> variant="arrowTriangle"</code>
          <Icon variant="arrowTriangle" width="l3" /> <code> width="l3" = 64px</code>
          <Icon variant="arrowTriangle" width="l2" /> <code> width="l2" = 48px</code>
          <Icon variant="arrowTriangle" width="l1" /> <code> width="l1" = 40px</code>
          <Icon variant="arrowTriangle" width="xl" /> <code> width="xl" = 32px</code>
          <Icon variant="arrowTriangle" width="lg" /> <code> width="lg" = 24px</code>
          <Icon variant="arrowTriangle" width="md" /> <code> width="md" = 18px</code>
          <Icon variant="arrowTriangle" width="sm" /> <code> width="sm" = 16px</code>
          <Icon variant="arrowTriangle" width="xs" /> <code> width="xs" = 12px</code>
          <Icon variant="arrowTriangle" width="s2" /> <code> width="s2" = 6px</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowClose" width="xl" />
          <code> variant="arrowClose"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowOpen" width="xl" />
          <code> variant="arrowOpen"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowNext" width="xl" />
          <code>variant="arrowNext"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowPrev" width="xl" />
          <code>variant="arrowPrev"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowFoldout" selected={true} width="xl" />
          <code>variant="arrowFoldout" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowFoldout" selected={false} width="xl" />
          <code>variant="arrowFoldout" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowFoldoutPurple" selected={true} width="xl" />
          <code>variant="arrowFoldoutPurple" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowFoldoutPurple" selected={false} width="xl" />
          <code>variant="arrowFoldoutPurple" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowRotate" width="xl" selected />
          <code>variant="arrowRotate" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowPath" width="xl" variantInvert />
          <code>variant="arrowPath" variantInvert</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowPath" width="xl" selected />
          <code>variant="arrowPath" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowPath" width="xl" unselected />
          <code>variant="arrowPath" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowCursor" width="xl" />
          <code>variant="arrowCursor"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowTriangle" width="xl" />
          <code>variant="arrowTriangle"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="briefcase" width="xl" />
          <code>variant="briefcase"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="moneyPaper" width="xl" />
          <code>variant="moneyPaper"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="building" width="xl" />
          <code>variant="building"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="buildingLibrary" width="xl" />
          <code>variant="buildingLibrary"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="userGroup" width="xl" />
          <code>variant="userGroup"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="userGroup" width="xl" selected />
          <code>variant="userGroup" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="users" width="xl" />
          <code>variant="users"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="user" width="xl" />
          <code>variant="user"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="user" width="xl" selected />
          <code>variant="user" selected </code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="gift" width="xl" unselected />
          <code>variant="gift" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="calendarEmpty" width="xl" />
          <code>variant="calendarEmpty"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="calendarEmpty" width="xl" selected />
          <code>variant="calendarEmpty" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="calendarEmpty" selected width="xl" variantInvertDark />
          <code>variant="calendarEmpty" selected variantInvertDark</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="calendarEmptyRed" width="xl" selected />
          <code>variant="calendarEmptyRed" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="calendarSolid" width="xl" />
          <code>variant="calendarSolid"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="calendarDays" width="xl" selected />
          <code>variant="calendarDays" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="calendarDays" width="xl" unselected />
          <code>variant="calendarDays" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="shoppingBag" width="xl" unselected />
          <code>variant="shoppingBag" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="cloudOff" width="xl" />
          <code>variant="cloudOff"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="cloudOn" width="xl" />
          <code>variant="cloudOn"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="clipboardDoc" width="xl" />
          <code>variant="clipboardDoc" </code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="wifi" width="xl" />
          <code>variant="wifi" </code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="envelope" width="xl" selected />
          <code>variant="envelope" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="envelope" width="xl" />
          <code>variant="envelope" </code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="deviceTablet" width="xl" />
          <code>variant="deviceTablet" </code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="document" width="xl" />
          <code>variant="document"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="bubbleNeutral" width="xl" />
          <code>variant="bubbleNeutral" </code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="bubble" width="xl" />
          <code>variant="bubble" </code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="bubble" width="xl" selected />
          <code>variant="bubble" selected </code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="newspaper" width="xl" selected />
          <code>variant="newspaper" selected </code>
        </div>

        <div className={CN.iconContainer}>
          <Icon variant="drag" width="xl" />
          <code>variant="drag"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="hashtag" width="xl" />
          <code>variant="hashtag"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="lock" width="xl" />
          <code>variant="lock"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="lockClose" width="xl" />
          <code>variant="lockClose"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="lockOpen" width="xl" />
          <code>variant="lockOpen"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="padlock" width="xl" />
          <code>variant="padlock"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="padlock" width="xl" selected />
          <code>variant="padlock" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="padLockV2" width="xl" selected />
          <code>variant="padLockV2" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="padLockV2" width="xl" />
          <code>variant="padLockV2" </code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="phone" width="xl" unselected />
          <code>variant="phone" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="phoneOutline" width="xl" />
          <code>variant="phoneOutline" </code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="percent" width="xl" />
          <code>variant="percent"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="pound" width="xl" />
          <code>variant="pound"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="poundYellow" width="xl" />
          <code>variant="poundYellow"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="currency" width="xl" />
          <code>variant="currency"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="shield" width="xl" />
          <code>variant="shield"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="refund" width="xl" />
          <code>variant="refund"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="label" width="xl" />
          <code>variant="label" white</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="reports" width="xl" />
          <code>variant="reports"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="computer" width="xl" selected />
          <code>variant="computer" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="computer" width="xl" unselected />
          <code>variant="computer" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="error" width="xl" />
          <code>variant="error"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="errorTriangle" width="xl" />
          <code>variant="errorTriangle"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="checkCircle" width="xl" />
          <code>variant="checkCircle"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="checkCircleSolid" width="xl" />
          <code>variant="checkCircleSolid"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="clockCircleSolid" width="xl" />
          <code>variant="clockCircleSolid"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="clockCircleEmpty" width="xl" />
          <code>variant="clockCircleEmpty"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="xCircle" width="xl" />
          <code>variant="xCircle"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="xCircleSolid" width="xl" />
          <code>variant="xCircleSolid"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="radioCheck" selected={true} width="xl" />
          <code>variant="radioCheck" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="radioCheckNeutral" selected width="xl" />
          <code>variant="radioCheckNeutral" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="radioCheck" selected={false} width="xl" />
          <code>variant="radioCheck" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="radio" selected={true} width="xl" />
          <code>variant="radio" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="radio" selected={false} width="xl" />
          <code>variant="radio" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="markSquareUnselected" width="xl" />
          <code>variant="markSquareUnselected" DEPRECATED use variant="check"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="markSquare" width="xl" />
          <code>variant="markSquare" DEPRECATED use variant="check"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="check" selected={true} width="xl" />
          <code>variant="check" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="check" selected={false} width="xl" />
          <code>variant="check" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <TypedOption type="simple-checkbox" name="" checked={true} onCheck={alwaysNoop}></TypedOption>
          <code>TypedOption type="simple-checkbox"</code>
        </div>
        <div className={CN.iconContainer}>
          <TypedOption type="simple-checkbox" name="" checked={false} onCheck={alwaysNoop}></TypedOption>
          <code>TypedOption type="simple-checkbox"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="questionSolid" width="xl" />
          <code>variant="questionSolid"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="fbWhite" width="xl" />
          <code>variant="fbWhite"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="pay" width="xl" selected />
          <code>variant="pay" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="pay" width="xl" unselected />
          <code>variant="pay" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="pencil" width="xl" />
          <code>variant="pencil"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="pencilGrayscale" width="xl" />
          <code>variant="pencilGrayscale"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="paperClip" width="xl" />
          <code>variant="paperClip"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="note" width="xl" />
          <code>variant="note"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="pencilNotes" width="xl" />
          <code>variant="pencilNotes"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="pencilNotes" width="xl" selected />
          <code>variant="pencilNotes" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="history" width="xl" />
          <code>variant="history"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="history" width="xl" selected />
          <code>variant="history" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="settings" width="xl" selected />
          <code>variant="settings" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="settings" width="xl" unselected />
          <code>variant="settings" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="cog" width="xl" selected />
          <code>variant="cog" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="smsBubble" width="xl" selected />
          <code>variant="smsBubble" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="bell" width="xl" selected />
          <code>variant="bell" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="giftVoucher" width="xl" />
          <code>variant="giftVoucher"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="handUp" width="xl" />
          <code>variant="handUp"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="handDown" width="xl" />
          <code>variant="handDown"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="handDownRed" width="xl" />
          <code>variant="handDownRed"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="alert" width="xl" />
          <code>variant="alert"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="confirm" width="xl" />
          <code>variant="confirm"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="confirmSquare" width="xl" />
          <code>variant="confirmSquare"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="warningCircle" width="xl" />
          <code>variant="warningCircle"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="lockDisabled" width="xl" />
          <code>variant="lockDisabled"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="warning" width="xl" />
          <code>variant="warning"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="minus" width="xl" />
          <code>variant="minus"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="plus" width="xl" />
          <code>variant="plus"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="minusV2" width="xl" selected />
          <code>variant="minusV2" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="plusV2" width="xl" selected />
          <code>variant="plusV2" selected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="delete" width="xl" />
          <code>variant="delete"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="bin" width="xl" />
          <code>variant="bin"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="stripeWhite" width="xl" />
          <code>variant="stripeWhite"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="stripeBlue" width="xl" />
          <code>variant="stripeBlue"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="instagram" width="xl" />
          <code>variant="instagram"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="essential" width="xl" />
          <code>variant="essential"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="super" width="xl" />
          <code>variant="super"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="advanced" width="xl" />
          <code>variant="advanced"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="star" selected={false} width="xl" />
          <code>variant="star"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="emptyStar" selected={false} width="xl" />
          <code>variant="emptyStar" white</code>
        </div>

        <div className={CN.iconContainer}>
          <Icon variant="off" width="xl" />
          <code>variant="off"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="on" width="xl" />
          <code>variant="on"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="instagram" width="xl" />
          <code>variant="instagram"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="info" width="xl" />
          <code>variant="info"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="close" width="xl" />
          <code>variant="close"</code> icon is white
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="closeDark" width="xl" />
          <code>variant="closeDark"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="xRed" width="xl" />
          <code>variant="xRed"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowBack" width="xl" />
          <code>variant="arrowBack"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowLeft" width="xl" />
          <code>variant="arrowLeft"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="arrowRight" width="xl" />
          <code>variant="arrowRight"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="circleWithArrowLeft" width="xl" />
          <code>variant="circleWithArrowLeft"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="markCircle" width="xl" />
          <code>variant="markCircle"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="tick" width="xl" />
          <code>variant="tick"</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="tick" width="xl" unselected />
          <code>variant="tick" unselected</code>
        </div>
        <div className={CN.iconContainer}>
          <Icon variant="tick" width="xl" selected />
          <code>variant="tick" selected</code>
        </div>
      </div>
      <div className={CN.verticalFlex}></div>
    </div>
  </div>
);

// noinspection JSUnusedGlobalSymbols
export default IconsPanel;
